export default "__VITE_ASSET__Bke7i0Am__"